module.exports = __webpack_public_path__ + "img/def-scene-1.d010681c.jpg";